import app from '$$app';

export default function (instance) {
  return {
    show(id, column, config, placeholder) {
      const pos = placeholder.getBoundingClientRect();

      pos.x += 8;

      app.trigger('showTimeTrackingPopup', 'task', pos, +id, () => {
        instance.ext.inlineEditors.hide();
      });
    },

    hide() {
      app.trigger('hideTimeTrackingPopup');
    },

    set_value(value, id, column, node) {
    },

    get_value(id, column, node) {
    },

    is_changed(value, id, column, node) {
      return true;
    },

    is_valid(value, id, column, node) {
      return true;
    },

    save(id, column, node) {
    },

    focus(node) {
    },
  };
}
